<template>
  <v-container>
    <base-material-card
      icon="mdi-plus"
      title="Group create"
      class="px-5 py-3"
    >
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
            sm="6"
          >
            <v-text-field
              outlined
              label="Guruh nomi"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
            sm="6"
          >
            <v-text-field
              outlined
              label="Fakultet"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
            sm="6"
          >
            <v-text-field
              outlined
              label="Yo'nalish"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
            sm="12"
          >
            <v-text-field
              outlined
              label="Kurs"
            />
          </v-col>
        </v-row>

        <base-material-card
          icon="mdi-text-subject"
          title="Subjects"
          class="px-5"
        >
          <v-row class="container">
            <v-btn color="red">
              <v-icon>mdi-trash-can-outline</v-icon>
              Delete
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              @click="dialog3 = true"
            >
              <v-icon>mdi-plus</v-icon>
              Add Subject
            </v-btn>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="group.subjects"
            :items-per-page="5"
            :item-key="group.name"
          >
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </base-material-card>
      </v-card-text>
      <v-card-actions class="pb-6 text-center">
        <v-btn
          text
          @click="dialog = false"
        >
          Back
        </v-btn>
        <v-spacer />
        <v-btn
          color="success"
          @click="dialog = false"
        >
          Save
        </v-btn>
      </v-card-actions>
    </base-material-card>

    <!--    Dialog          xxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    <v-dialog
      persistent
      v-model="dialog3"
      max-width="600"
    >
      <v-card>
        <v-card-title>
          Are you sure?

          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="dialog3 = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-row class="container pt-12 pl-10">
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="subject.name"
              label="Subject name"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="examDate"
              label="Date"
              outlined
              type="date"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="startTime"
              label="Start time"
              outlined
              :items="dateTimes"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="finishTime"
              label="Finish time"
              outlined
              :items="dateTimes"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="subject.time"
              label="Exam time"
              outlined
              :items="times"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="subject.amountQuiz"
              label="Quiz amount"
              outlined
              type="number"
            />
          </v-col>
        </v-row>
        <v-card-text class="pb-6 text-center">
          <v-btn
            class="mr-10"
            text
            @click="closeDialog()"
          >
            Cancel
          </v-btn>

          <v-btn
            color="success"
            :disabled="isValidSubject"
            @click="addSubject()"
          >
            Add
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    name: 'GroupCreate',
    data () {
      return {
        group: {
          id: '',
          name: '',
          faculty: '',
          direction: '',
          course: '',
          subjects: [],
        },
        subject: {
          id: '',
          name: '',
          startDate: '',
          finishDate: '',
          time: '',
          amountQuiz: 20,
        },
        selectedIndex: -1,
        defaultSubject: {
          id: '',
          name: '',
          startDate: '',
          finishDate: '',
          time: '',
          amountQuiz: 20,
        },
        headers: [
          { text: 'Guruh nomi', value: 'name' },
          { text: 'Boshlanish vaqti', value: 'startDate' },
          { text: 'Tugash vaqti'.toUpperCase(), value: 'finishDate' },
          { text: 'Imtixon vaqti (mm)', value: 'time' },
          { text: 'Savollar soni', value: 'amountQuiz' },
          { text: 'Action', value: 'action' },
        ],
        startTime: '',
        finishTime: '',
        examDate: '',
        dialog3: false,
        dateTimes: ['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00',
                    '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '21:00', '22:00', '23:00'],
        times: ['0:20', '0:20', '0:30', '0:40', '0:50', '1:00'],
      }
    },
    computed: {
      isValidSubject () {
        return this.subject.name.length === 0 || this.startTime.length === 0 ||
          this.finishTime.length === 0 || this.subject.time.length === 0 || this.examDate.length === 0
      },
    },
    methods: {
      editItem (item) {
        this.selectedIndex = this.group.subjects.indexOf(item)
        this.subject = Object.assign({}, item)
        let date = new Date(Date.parse(this.subject.startDate))
        this.startTime = date.getHours() + ':00'
        date = new Date(Date.parse(this.subject.finishDate))
        this.finishTime = date.getHours() + ':00'
        this.subject.time = this.examTimeToString(this.subject.time)
        this.examDate = date
        this.dialog3 = true
      },
      closeDialog () {
        this.dialog3 = false
        this.subject = Object.assign({}, this.defaultSubject)
        this.selectedIndex = -1
        this.examDate = ''
        this.startTime = ''
        this.finishTime = ''
      },
      addSubject () {
        var date = new Date(this.examDate)
        date.setHours(this.getHour(this.startTime))
        this.subject.startDate = date.toUTCString()
        date.setHours(this.getHour(this.finishTime))
        this.subject.finishDate = date.toUTCString()
        this.subject.time = this.getExamTime(this.subject.time)
        this.selectedIndex === -1 ? this.group.subjects.push(this.subject) : this.group.subjects.splice(this.selectedIndex, 1, this.subject)

        this.closeDialog()
      },
      getHour (st) {
        return st.substring(0, st.indexOf(':'))
      },
      getExamTime (st) {
        const hour = st.substring(0, st.indexOf(':'))
        const minute = st.substring(st.indexOf(':') + 1)
        return +(minute) + +(hour * 60)
      },
      examTimeToString (minute) {
        const hour = Math.trunc(minute / 60)
        return hour + ':' + ((minute % 60) ? (minute % 60) : '00')
      },
    },
  }
</script>

<style scoped>

</style>
